<!-- Task List Content -->
<div class="pr-4">

  <nx-pageTitle-box
    [label]="'Meine Aufgaben'"
    [icon]="'icon-task'"
    [iconToolTip]="'Meine Aufgaben'">
      <ng-template nxTemplate="end">
        <div class="mr-2 justify-end">
          <input
              #globalSearch
              pInputText
              type="text"
              class="p-inputtext p-component p-element w-[300px]"
              placeholder="Aufgabe suchen" />
        </div>
        <nx-command-button
          *ngIf="rolesService.hasRole('nexcore_task_create')"
          #taskListComp
          [reloadable]="reloadable"
          [style]="'light'"
          [commandName]="'taskCreateCommand'"
          [icon]="'icon-plus'">
        </nx-command-button>
    </ng-template>
  </nx-pageTitle-box>

  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [showClear]="true"
        placeholder="Typ"
        [ngModel]="typesModel()"
        (ngModelChange)="onTypesChange($event)"
        [options]="typeOptions()"
        [optionValue]="'id'"
        optionLabel="label">
        <ng-template let-option pTemplate="item">
          <div class="inline-block vertical-align-middle">
            <span class="ml-1 mt-1">{{ option.name }}</span>
          </div>
        </ng-template>
      </nx-filter-multiSelect>

      <!-- Filter: Location -->
      <nx-filter-multiSelect
        [className]="'table-filter'"
        [filter]="false"
        [showToggleAll]="false"
        [showHeader]="false"
        [appendTo]="'body'"
        [ngModel]="locationsModel()"
        (ngModelChange)="onLocationsChange($event)"
        [options]="locationsOptions()"
        [showClear]="true"
        [placeholder]="'Niederlassung'"
        [dataKey]="'id'"
        [optionValue]="'id'"
        optionLabel="name">
        <ng-template pTemplate="selectedItems" let-locations>
          @if (locations?.length > 1) {
            Niederlassung: <span class="ml-1">{{ locations.length }} ausgewählt</span>
          } @else {
            @for (location of locations; track location.id; let isFirst = $first) {
              Niederlassung: {{ location.name }}
            }
            @empty {
              Niederlassung
            }
          }
        </ng-template>
      </nx-filter-multiSelect>

      <nx-filter-date-select
        [className]="'table-filter'"
        placeholder="Fällig"
        [showIncludeOverDue]="true"
        [includeOverDueLabel]="'inkl. überfällige'"
        [ngModel]="dueDateModel()"
        (ngModelChange)="dueDateModel.set($event)"
        (onClear)="onDueDateChange()"
        (onChange)="onDueDateChange()"
        optionLabel="label">
      </nx-filter-date-select>
    </div>

    <div class="flex flex-row justify-start lg:justify-end">
      <nx-sort-select
        class="mr-2"
        placeholder="Sortierung"
        [appendTo]="'body'"
        [showNoSortOption]="true"
        [ngModel]="sortModel()"
        (ngModelChange)="onSortChange($event)"
        [options]="sortFields">
      </nx-sort-select>
      <nx-field-selector
        class="mr-2"
        [availableFields]="availableFields"
        [displayedFields]="displayedFields()"
        [defaultFields]="['address', 'order', 'customer', 'resources']"
        [showMetadata]="showMetadata()"
        (displayedFieldsChange)="displayedFields.set($event)"
        (showMetadataChange)="showMetadata.set($event)">
      </nx-field-selector>
    </div>
  </div>

  <!-- Task List -->
  <div>
    <div>
      @for (task of tasks(); track task.id; let isLast = $last) {
        <app-task-row-v2-component
          [task]="task"
          [hideLastBorder]="isLast"
          [isLast]="isLast"
          [displayedFields]="displayedFields()"
          [showMetadata]="showMetadata()">
        </app-task-row-v2-component>
      }
      <nx-empty-box
        class="border-t"
        *ngIf="tasks().length === 0"
        [label]="'Keine Aufgaben gefunden.'">
      </nx-empty-box>
    </div>

    <!-- Pagination -->
    <nx-simple-paginator
      [currentPage]="pageNumber()"
      [pageSize]="pageSize()"
      [totalElements]="totalElements()"
      [pageSizeOptions]="[15, 30, 50]"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)">
    </nx-simple-paginator>
  </div>

</div>

